module.exports = __webpack_public_path__ + "22b85811826e636de667a6bc3213cc2f.png";